import { SET_MAP_SWITCHER_STATE } from './constants';
export const actionSetMapSwitcherState = (payload) => ({
    type: SET_MAP_SWITCHER_STATE,
    payload,
});
//# sourceMappingURL=actions.js.map